define((require) => {
    "use strict";

    var Backbone      = require("backbone"),
        ImprovedModel = require("shared/zbone/ImprovedModel"),
        Permissions   = require("shared/security/Permissions"),
        RestApi       = require("shared/services/RestApi"),
        Syncer        = require("shared/services/sync/Syncer"),
        Widget        = require("ui/experience/widgets/Widget");

    /**
     * A widget prototype acts as a template that allows widget instances to be created based on
     * it, initialised with its prototypical data and a reference to the prototype it was created
     * from (id). Such widget instances (data) will then be embedded in Experiences, where they can
     * be primed with Experience specific data to activate, such as a product id for an associated
     * widget action to activate.
     * */
    return ImprovedModel.extend("PrototypeWidget", {

        defaults: {
            action: null,
            companyId: null
        },

        relations: [{
            key: "widget",
            relatedModel: Widget,
            type: Backbone.One
        }],

        constructor: function() {
            this.__super();

            Syncer.State.init(this, {
                permissions: {
                    destroy: Permissions.Privileges.ADMIN,
                    save:    Permissions.Privileges.ADMIN
                }
            });
        },

        /**
         * Returns the REST API URL for a PrototypeWidget. Used internally by the synchronization
         * mechanism.
         *
         * @returns {String} REST API URL
         */
        url: function() {
            var id = this.get("id");

            if (id) {
                // URL for GET, PUT and DELETE, i.e. "api/widgets/{widgetId}"
                return RestApi.pathToSpecificResource(RestApi.Collections.WIDGETS, id);
            }

            // URL for POST, i.e. "api/widgets"
            return RestApi.pathToCollection(RestApi.Collections.WIDGETS);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/PrototypeWidget.js